import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/number';
import 'isomorphic-fetch';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './app';

import './lib/polyfills';

function buildAppRoot() {
  const appRoot = document.createElement('div');
  document.body.appendChild(appRoot);

  return appRoot;
}

function start() {
  ReactDOM.render(<App />, buildAppRoot());
}

start();



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/index.tsx